import axios from "axios";
import { API_BASE_URL, API_ENDPOINTS, DEFAULT_HEADERS, LANDING_PAGE_BASE_URL } from "./config";

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: DEFAULT_HEADERS,
  timeout: 300000,
  withCredentials: true,
});

// NEW: Separate instance for Landing Pages (n8n webhook)
const landingPageClient = axios.create({
  baseURL: LANDING_PAGE_BASE_URL,
  headers: DEFAULT_HEADERS,
  timeout: 30000, // Slightly shorter timeout for landing pages
});

// Optional: Add the same response interceptor logic to the new client
landingPageClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    console.error("Landing Page API Error:", error.message);
    return Promise.reject(error);
  }
);
// Request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // Add any request modifications here if needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // Handle common errors
    if (error.response) {
      // Server responded with error status
      console.error("API Error:", error.response.status, error.response.data);
    } else if (error.request) {
      // Network error
      console.error("Network Error:", error.message);
    } else {
      // Other error
      console.error("Error:", error.message);
    }
    return Promise.reject(error);
  }
);

// Simple API functions
export const api = {
  get: (url, config = {}) => apiClient.get(url, config),
  post: (url, data = {}, config = {}) => apiClient.post(url, data, config),
  put: (url, data = {}, config = {}) => apiClient.put(url, data, config),
  delete: (url, config = {}) => apiClient.delete(url, config),
  getLandingPage: (payload) => apiClient.post(API_ENDPOINTS.LANDING_PAGE, payload),
};

export default apiClient; 